<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section class="my-2">
    <h4>Filters</h4>

    <div class="row">
      <section class="col-sm-3">
        <label>Visitor First Name</label>
        <b-form-input
          @keyup.enter="search()" cy="firstname"
          @input="updateFilter('visitorFirstName', $event)"
          :value="filters.visitorFirstName"
          class="mb-1" placeholder="Enter first name"
        />
      </section>

      <section class="col-sm-3">
        <label>Visitor Last Name</label>
        <b-form-input
          @keyup.enter="search()" cy="lastname"
          @input="updateFilter('visitorLastName', $event)"
          :value="filters.visitorLastName"
          class="mb-1" placeholder="Enter last name"
        />
      </section>

      <section class="col-sm-3">
        <label>{{ 'prison' | term(true) }} Number</label>
        <b-form-input
          @keyup.enter="search()" cy="prisonerNumber"
          @input="updateFilter('prisonerNumber', $event.toUpperCase())"
          :value="filters.prisonerNumber"
          class="mb-1" :placeholder="`Enter ${$options.filters.term('prison')} number`"
        />
      </section>

      <section class="col-sm-3">
        <label>Before Date <feather-icon v-b-tooltip.hover title="Show only records booked before this date." icon="InfoIcon" size="14" /></label>
        <b-form-datepicker @input="updateFilter('before', $event, true)" :value="filters.before"
                           today-button cy="before"
                           reset-button
                           close-button
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </section>

      <section class="col-sm-3">
        <label>After Date <feather-icon v-b-tooltip.hover title="Show only records booked on or after this date." icon="InfoIcon" size="14" /></label>
        <b-form-datepicker @input="updateFilter('after', $event, true)" :value="filters.after"
                           today-button cy="after"
                           reset-button
                           close-button
                           :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        ></b-form-datepicker>
      </section>

      <section class="col-sm-3" v-if="prison && prison.enable_wings">
        <label>Wing</label>
        <b-form-select cy="wing" @change="updateFilter('wingId', $event, true)" :value="filters.wingId" class="mb-1">
          <b-form-select-option value="">All Wings</b-form-select-option>
          <b-form-select-option v-for="wing in wings" :key="wing._id" :value="wing._id">{{ wing.name }}</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col-sm-3" v-if="externalCancellation">
        <label>Cancellation Reviewed</label>
        <b-form-select cy="cancellation"
                       @change="updateFilter('externalCancellation', $event, true)"
                       :value="filters.externalCancellation" class="mb-1">
          <b-form-select-option value="">All</b-form-select-option>
          <b-form-select-option :value="true">Reviewed Cancellations</b-form-select-option>
          <b-form-select-option :value="false">Not yet reviewed</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col-sm-3">
        <label>Sort</label>
        <b-form-select cy="sort"
                       @change="updateFilter('sort', $event, true)" :value="filters.sort" class="mb-1">
          <b-form-select-option value="created_at">First Created At</b-form-select-option>
          <b-form-select-option value="-created_at">Last Created At</b-form-select-option>
          <b-form-select-option value="updated_at">Updated First</b-form-select-option>
          <b-form-select-option value="-updated_at">Recently updated</b-form-select-option>
          <b-form-select-option value="requested_booking_slot_1.start_date_time">First Requested by start time
          </b-form-select-option>
          <b-form-select-option value="-requested_booking_slot_1.start_date_time">Last Requested by start time
          </b-form-select-option>
          <b-form-select-option value="requested_booking_slot_1.end_date_time">First Requested by End Time
          </b-form-select-option>
          <b-form-select-option value="-requested_booking_slot_1.end_date_time">Last Requested by End Time
          </b-form-select-option>
          <b-form-select-option value="booked_slot.end_date_time">Upcoming Booked Dates</b-form-select-option>
          <b-form-select-option value="-booked_slot.end_date_time">Furthest Booked Dates</b-form-select-option>
        </b-form-select>
      </section>

      <section class="col align-items-center d-flex" style="margin-top: 7px">
        <div class="ui-spacer"></div>
        <b-button @click="clearFilters()">Clear filters</b-button>
        <b-button class="btn-success ml-1" @click="search()">Search</b-button>
      </section>
    </div>
  </section>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import WingService from '@/services/WingService';

export default {
  components: {},
  props: {
    externalCancellation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      filters: state => state.callList.filters,
    }),
  },
  data() {
    return {
      wings: [],
    };
  },
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    if (this.prison && this.prison.enable_wings) {
      this.wings = (await WingService.getWings()).data;
    }
  },
  methods: {
    updateFilter(filterName, e, refresh) {
      this.$store.commit('callList/SET_FILTER_ITEM', {name: filterName, value: e});

      if (refresh) {
        this.search();
      }
    },
    search() {
      dispatchEvent(new CustomEvent('callSearch', {}));
      // this.$emit('search', true);
    },
    clearFilters() {
      this.updateFilter('visitorFirstName', '');
      this.updateFilter('visitorLastName', '');
      this.updateFilter('prisonerNumber', '');
      this.updateFilter('before', '');
      this.updateFilter('after', '');
      this.updateFilter('external_cancellation', '');
      this.updateFilter('wingId', '');
      this.search();
    },
  },
};
</script>
